(function () {
    'use strict';
    app.controller('teamManagementController', ['$filter', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'teamManagementService', '$http', 'LoginService', function ($filter, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams, teamManagementService, $http, loginService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return
        }

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var startIndex = 0;
        $scope.userDetailscurrentPage = 0;
        $scope.userDetailsPageSize = 10;

        //$scope.selectedInstitute = {
        //    InstitutionId: 0,
        //    InstitutionName: '',
        //    isAffiliationExists: false,
        //    userDefinedAffiliation: ''
        //};

        //$scope.hideModal = function () {
        //    $('#teamSetup').modal('hide');
        //    $location.path('/landing')
        //}

        //$scope.selectAffiliation = function () {
        //    $('#affiliationName').val('');
        //    $scope.selectedInstitute.userDefinedAffiliation = "";
        //    $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
        //    if (!$scope.selectedInstitute.isAffiliationExists) {
        //        $scope.selectedInstitute.InstitutionName = $scope.profileData.InstitutionName;
        //    } else {
        //        if ($scope.profileData.InstitutionName.length == 0) {
        //            $scope.selectedInstitute.isAffiliationExists = false
        //        }
        //        $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.InstitutionName;
        //    }

        //    $('#affiliation').modal('show');
        //};

        $scope.reset = function () {
            $scope.models = {
                name: '',
                email: '',
                affiliation: '',
                admininstrator: true,
                active: true,
                expired: true,
                inactive: true,
                pending: true
            }

            $scope.teamMemberPagination = {
                currentPage: 1,
                itemsPerPage: 10,
                totalRows: 0,
                sortBy: 'eSpectraSubAssignID',
                reverse: false
            }

            //$scope.profileData = {
            //    InstitutionId: "",
            //    InstitutionName: "",
            //    teamDisplayName: ""
            //}
        }

        $scope.reset();

        $scope.goTeamData = function () {
            $location.path('/datamanagement/team');
        }

        //$scope.proceedTeamSetup = function () {
        //    progressBarService.showProgressBar();
        //    $scope.isDisabled = true;

        //    var data = {
        //        eSpectraTeamAffiliationID: $scope.profileData.InstitutionId,
        //        eSpectraTeamAffiliationName: $scope.profileData.InstitutionName,
        //        eSpectraTeamName: $scope.profileData.teamDisplayName
        //    }

        //    teamManagementService.saveIndividualTeam(data).then(function (response) {
        //        if (response != null && response.data.message != undefined) {
        //            $scope.modalMessage = response.data.message;
        //            $scope.isModalError = true;
        //            $scope.isDisabled = false;
        //        }
        //        else {
        //            $location.path('/landing')
        //        }
        //    });
        //}

        $scope.resetMemberList = function () {
            $scope.userDetailscurrentPage = 0;
            $scope.isSearchUsers = false;
            $scope.removeTeamMemberEmailIds = '';
            $scope.isTeamNameChanged = false;
            $scope.isUpdateTeamName = false;
            $scope.isDisabled = false;
            $scope.reset();
            $scope.getTeamDetails();
        }

        $scope.getTeamDetails = function () {
            progressBarService.showProgressBar();
            teamManagementService.getTeamDetailsByUserID().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    if (response.data.status == 1) {
                        $("#teamSetup").modal('show');
                        return;
                    }

                    $scope.teamData = response.data;
                    $scope.teamData.oldeSpectraTeamName = $scope.teamData.eSpectraTeamName;
                    //$scope.teamData.eSpectraSeatsRemaining = $scope.teamData.eSpectraTeamStatus.toLowerCase() == 'expired' ? 0 : $scope.teamData.eSpectraOrderQty - $scope.teamData.eSpectraSeatsAllocated;
                    $scope.getTeamMemberList();
                }
            });
        }

        $scope.getTeamDetails();

        $scope.getTeamMemberList = function (click) {
            progressBarService.showProgressBar();
            if (click == "search") {
                $scope.teamMemberData = [];
                $scope.teamMemberPagination.sortBy = 'eSpectraSubAssignID';
                $scope.teamMemberPagination.reverse = false;
            }
            var data = {
                eSpectraTeamPartyID: $scope.teamData.eSpectraTeamPartyID,
                eSpectraTeamMemberName: $scope.models.name,
                eSpectraTeamMemberEmail: $scope.models.email,
                eSpectraTeamAffiliationName: $scope.models.affiliation,
                Administrator: $scope.models.admininstrator ? '1' : '0',
                Active: $scope.models.active ? 'active' : '0',
                Expired: $scope.models.expired ? 'expired' : '0',
                //Inactive: $scope.models.inactive ? 'deactivated' : '0',
                Pending: $scope.models.pending ? 'pending' : '0',
                SortBy: $scope.teamMemberPagination.sortBy,
                Reverse: $scope.teamMemberPagination.reverse ? 'desc' : 'asc'
            }
            teamManagementService.getTeamMemberData(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.teamMemberData = response.data;
                    $scope.teamMemberStatusBackUp = [];
                    //teamMemberDataBackUp = response.data;
                    var countOfExpiredMembers = 0;
                    angular.forEach($scope.teamMemberData, function (value, key) {
                        $scope.teamMemberData[key].isShowNameTextField = false;
                        $scope.teamMemberData[key].isShowEmailTextField = false;
                        $scope.teamMemberData[key].isRenew = false;
                        $scope.teamMemberStatusBackUp[key] = value.eSpectraSubAssignStatus;
                        if ($scope.teamData.eSpectraTeamStatus.toLowerCase() == 'expired') {
                            $scope.teamMemberData[key].eSpectraSubAssignStatus = 'Expired';
                        }
                        if (value.eSpectraSubAssignStatus == 'Expired' || value.eSpectraSubAssignStatus == 'Inactive') {
                            $scope.teamMemberData[key].isRenewDisable = true;
                            $scope.teamMemberData[key].isRemoveDisable = true;
                            countOfExpiredMembers++;
                        } else {
                            $scope.teamMemberData[key].isRenewDisable = false;
                            $scope.teamMemberData[key].isRemoveDisable = false;
                        }
                    });

                    $scope.teamData.eSpectraSeatsRemaining = $scope.teamData.eSpectraTeamStatus.toLowerCase() == 'expired' ? 0 : ($scope.teamData.eSpectraOrderQty - $scope.teamData.eSpectraSeatsAllocated) + countOfExpiredMembers;

                    if (data.Inactive != 0 && data.eSpectraTeamMemberName == "" && data.eSpectraTeamMemberEmail == "") {
                        var countOfSeatsRequired = $scope.teamData.eSpectraTeamStatus.toLowerCase() == 'expired' && $scope.teamData.eSpectraSeatsAllocated == countOfExpiredMembers ? $scope.teamData.eSpectraSeatsAllocated : $scope.teamData.eSpectraSeatsAllocated - countOfExpiredMembers;
                        if ($scope.teamData.eSpectraOrderQty != countOfSeatsRequired) {
                            $scope.startIndex = $scope.teamMemberData.length;

                            var remainingQty = $scope.teamData.eSpectraOrderQty - countOfSeatsRequired
                            for (var i = startIndex; i < startIndex + remainingQty; i++) {
                                $scope.teamMemberData.push({
                                    eSpectraTeamMemberName: '',
                                    eSpectraTeamMemberEmail: '',
                                    eSpectraOrderStartDate: $scope.teamData.eSpectraOrderStartDate,
                                    eSpectraOrderEndDate: $scope.teamData.eSpectraOrderEndDate,
                                    eSpectraSubAssignStatus: $scope.teamData.eSpectraTeamStatus.toLowerCase() == 'expired' ? 'Expired' : 'Inactive',
                                    isRenew: false,
                                    isRenewDisable: true,
                                    isRemoveDisable: true,
                                    isShowNameTextField: true,
                                    isShowEmailTextField: true,

                                });
                            }
                            var index = $scope.startIndex;
                            angular.forEach($scope.teamData.eSpectraTeamOrderDetails, function (value, key) {
                                if (value.eSpectraOrderQty - value.eSpectraSeatsAllocated > 0) {
                                    var condition = value.eSpectraOrderQty - value.eSpectraSeatsAllocated;
                                    for (var i = index; i < condition + index; i++) {
                                        $scope.teamMemberData[i].eSpectraOrderStartDate = value.eSpectraOrderStartDate;
                                        $scope.teamMemberData[i].eSpectraOrderEndDate = value.eSpectraOrderEndDate;
                                    }
                                    index = index + condition;
                                }
                            })
                        }
                    }
                    //if (!isSort) {
                    //    $scope.getcountryData();
                    //}
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.exportReportData = function () {
            progressBarService.showProgressBar();
            $scope.getCurrentDate();
            var data = {
                eSpectraTeamPartyID: $scope.teamData.eSpectraTeamPartyID,
                eSpectraTeamMemberName: $scope.models.name,
                eSpectraTeamMemberEmail: $scope.models.email,
                eSpectraTeamAffiliationName: $scope.models.affiliation,
                Administrator: $scope.models.admininstrator ? '1' : '0',
                Active: $scope.models.active ? 'active' : '0',
                Expired: $scope.models.expired ? 'expired' : '0',
                //Inactive: $scope.models.inactive ? 'deactivated' : '0',
                Pending: $scope.models.pending ? 'pending' : '0',
                PageNo: $scope.teamMemberPagination.currentPage,
                SortBy: $scope.teamMemberPagination.sortBy,
                Reverse: $scope.teamMemberPagination.reverse ? 'desc' : 'asc'
            }

            teamManagementService.getTeamMemberDataReport(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    var csv = convertArrayOfObjectsToCSV({
                        data: response.data
                    });

                    BlobDownloadCSV('TeamManagementReport_' + $scope.currentDate + '.csv', csv)
                }

                progressBarService.hideProgressBar();
            });
        }

        function convertArrayOfObjectsToCSV(args) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';


            keys = Object.keys(data[0]).slice(1);

            headers = ["Name",
                    "Email",
                    "Start Date",
                    "End Date",
                    "Status"]

            result = 'Report Name' + columnDelimiter + "Team Management Report" + lineDelimiter;
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.getCurrentDate = function () {
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            $scope.currentDate = mm + '/' + dd + '/' + yyyy;
        }

        $scope.sortTeamMembers = function (sortBy) {
            if ($scope.teamMemberData.length > 0) {
                $scope.teamMemberPagination.sortBy = sortBy;
                $scope.teamMemberPagination.currentPage = 1;
                $scope.teamMemberPagination.reverse = !$scope.teamMemberPagination.reverse;
                $scope.getTeamMemberList();
            }
        }

        $scope.removeTeamMember = function (index) {
            if (!$scope.teamMemberData[index].isRemoveDisable) {
                $scope.removeTeamMemberEmailIds = $scope.removeTeamMemberEmailIds + $scope.teamMemberData[index].eSpectraTeamMemberEmail + ',';
                $scope.teamMemberData[index].eSpectraSubAssignStatus = 'Inactive';
                $scope.teamMemberData[index].isRenewDisable = true;
                $scope.teamMemberData[index].isShowUndo = true;
                $scope.teamMemberData[index].isRemoveDisable = true;
            }
        }

        $scope.undoTeamMember = function (index) {
            $scope.teamMemberData[index].eSpectraSubAssignStatus = $scope.teamMemberStatusBackUp[index];
            $scope.removeTeamMemberEmailIds = $scope.removeTeamMemberEmailIds.replace($scope.teamMemberData[index].eSpectraTeamMemberEmail + ',', '');
            $scope.teamMemberData[index].isRenewDisable = false;
            $scope.teamMemberData[index].isShowUndo = false;
            $scope.teamMemberData[index].isRemoveDisable = false;
        }

        $scope.saveAdminUpdatedTeamProfile = function () {
            progressBarService.showProgressBar();
            if ($scope.teamData.oldeSpectraTeamName != $scope.teamData.eSpectraTeamName) {
                $scope.isTeamNameChanged = true;
            }

            var removed = $scope.removeTeamMemberEmailIds != "" ? $scope.removeTeamMemberEmailIds.split(',') : "";
            var eSpectraMembers = [];

            angular.forEach(removed, function (value, key) {
                eSpectraMembers.push({ eSpectraTeamMemberEmail: value, isRemoved: 1, eSpectraTeamPartyID: $scope.teamData.eSpectraTeamPartyID });
            });

            var tempName = [], invalidData = 0;
            angular.forEach($scope.teamMemberData, function (value, key) {
                tempName = value.eSpectraTeamMemberName.split(' ')
                if (value.eSpectraTeamMemberName != "" && value.eSpectraTeamMemberEmail != "" && value.isShowNameTextField == true) {
                    eSpectraMembers.push({
                        eSpectraTeamMemberFirstName: tempName[0],
                        eSpectraTeamMemberLastName: tempName[1],
                        eSpectraTeamMemberEmail: value.eSpectraTeamMemberEmail,
                        iseSpectraTeamAdmin: '0',
                        isAdded: 1,
                        eSpectraTeamPartyID: $scope.teamData.eSpectraTeamPartyID
                    });
                } else if ((value.eSpectraTeamMemberName == "" && value.eSpectraTeamMemberEmail != "") || (value.eSpectraTeamMemberEmail == "" && value.eSpectraTeamMemberName != "")) {
                    invalidData++;
                }
            });

            if (invalidData == 0) {
                var data = {
                    eSpectraTeamName: $scope.teamData.eSpectraTeamName,
                    eSpectraTeamAffiliationName: $scope.teamData.eSpectraTeamAffiliationName,
                    isTeamNameChanged: $scope.isTeamNameChanged,
                    eSpectraTeamPartyID: $scope.teamData.eSpectraTeamPartyID,
                    eSpectraTeamMember: eSpectraMembers
                };

                teamManagementService.saveAdminUpdatedTeamProfile(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        $scope.isUpdateTeamName = false;
                        progressBarService.hideProgressBar();
                    }
                    else {
                        $scope.message = "Data has been saved successfully.";
                        $scope.isError = false;
                        $scope.isSuccess = true;
                        $scope.isTeamNameChanged = false;
                        $scope.isUpdateTeamName = false;
                        $scope.removeTeamMemberEmailIds = "";

                        angular.forEach(data.eSpectraMembers, function (value, key) {
                            if (value.eSpectraTeamMemberEmail == $scope.adminID) {
                                loginService.refreshToken();
                            }
                        });

                        $scope.getTeamDetails();
                    }
                });
            } else {
                progressBarService.hideProgressBar();
            }
        };

        $scope.checkValidEmail = function (event, index) {
            var count = 0, i, emailregx;
            emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ($(event.currentTarget).val() == $scope.adminID) {
                $scope.isDisabled = true;
            } else {
                $scope.isDisabled = false;
            }

            for (i = startIndex; i < $scope.teamMemberData.length; i++) {
                if ($scope.teamMemberData[i].eSpectraTeamMemberEmail != "" && $scope.teamMemberData[i].eSpectraTeamMemberEmail != undefined) {
                    if (emailregx.test($scope.teamMemberData[i].eSpectraTeamMemberEmail)) {

                        $('#memberEmail_' + i).removeClass('border-red');
                        count = count + 1;
                    }
                    else {
                        count = 0;
                        $('#memberEmail_' + i).addClass('border-red');
                    }
                } else if ($scope.teamMemberData[i].eSpectraTeamMemberEmail == undefined) {
                    $('#memberEmail_' + i).addClass('border-red');
                }
                else if ($scope.teamMemberData[i].eSpectraTeamMemberName == "") {
                    $('#memberEmail_' + i).removeClass('border-red');
                    //count = count + 1;
                }
            }
            if (count > 0) {
                $scope.isDisabled = false;
                $scope.checkDuplicateEmailIDS();
            } else {
                if ($scope.teamMemberData.length >= 1) {
                    $scope.isDisabled = true;
                }
            }
        }

        $scope.checkDuplicateEmailIDS = function () {
            for (var i = 0; i < $scope.teamMemberData.length; i++) {
                for (var x = i + 1; x < $scope.teamMemberData.length; x++) {
                    if ($scope.teamMemberData[i].eSpectraTeamMemberEmail != "" && ($scope.teamMemberData[i].eSpectraTeamMemberEmail == $scope.teamMemberData[x].eSpectraTeamMemberEmail && $scope.teamMemberData[i].eSpectraSubAssignStatus.toLowerCase() != 'inactive')) {
                        $scope.isDisabled = true;
                        return false;
                    }
                    else {
                        $scope.isDisabled = false;
                    }
                }
            }
        }

        $scope.isSearchUsers = false;
        $scope.removeTeamMemberEmailIds = '';
        $scope.isTeamNameChanged = false;
        $scope.isUpdateTeamName = false;
        $scope.isDisabled = false;
        $scope.adminID = getLocalValue("emailId");
        $scope.noLicensesToRenew = 0;

        $scope.showNextUserDetailsPage = function () {
            $scope.userDetailscurrentPage = $scope.userDetailscurrentPage + 1;
        }

        $scope.changeTeamName = function () {
            $scope.isUpdateTeamName = true;
        }

        $scope.cancelUpdateTeamName = function () {
            $scope.isUpdateTeamName = false;
        }

        $scope.renewChk = function () {
            var quantity = $('input.renew[type="checkbox"]:checked').length;

            if (quantity > 0) {
                $scope.noLicensesToRenew = quantity;
            } else {
                $scope.noLicensesToRenew = 0;
            }
        };

        $scope.renewLicenses = function () {
            var cost = $scope.teamData.costForOneMember;
            var quantity = 0;
            angular.forEach($scope.teamMemberData, function (value, key) {
                if (value.isRenew == true) {
                    quantity++;
                }
            });
            if (quantity > 0) {
                $scope.noLicensesToRenew = quantity;
                $scope.costToRenewLicenses = cost * quantity;
                $('#renewLicensesModal').modal('show');
            }
        }

        $scope.addUser = function () {
            $location.path('/accessOption/team');
            setLocalValue("teamPartyID", $scope.teamData.eSpectraTeamPartyID);
        }

    }]);
})();